import {
  SimpleEmptyStateContainer,
  SimpleEmptyStateTitle,
  SimpleEmptyStateDescription,
} from './SimpleEmptyState.styled';

interface SimpleEmptyStateProps {
  title: string;
  description: string;
}

export default function SimpleEmptyState({
  title,
  description,
}: SimpleEmptyStateProps) {
  return (
    <SimpleEmptyStateContainer>
      <SimpleEmptyStateTitle>{title}</SimpleEmptyStateTitle>
      <SimpleEmptyStateDescription>{description}</SimpleEmptyStateDescription>
    </SimpleEmptyStateContainer>
  );
}
